<template>
  <BreadCrumb PageTitle="Edit Course" />
  <EditCourse />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import EditCourse from "../../template-components/ELearning/EditCourse/EditCourse.vue";

export default defineComponent({
  name: "EditCoursePage",
  components: {
    BreadCrumb,
    EditCourse,
  },
});
</script>